import { c as _c } from "react/compiler-runtime";
import { AppLayout } from '@src/components/sco/AppLayout';
import { AppLayoutPanelProps } from '@src/components/sco/AppLayout/Panel';
import { RequestsNav } from '@src/components/sco/Requests/Layout/RequestsNav';
import { ManageRequestAuthGate } from '@src/components/sco/Requests/ManageRequestAuthGate';
import { UserAccessGate } from '@src/components/sco/UserAccessGate';
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar';
import { HubspotHideChatStyles } from '@src/components/sco/utilities/HubspotChatHandler/HubspotHideChatStyles';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { useLoginHref } from '@src/hooks/useLoginHref';
import { useWindow } from '@src/hooks/useWindow';
import { usePathname } from 'next/navigation';
import React, { ReactNode, useMemo } from 'react';
type RequestsLayoutProps = {
  asidePanel?: ReactNode;
  mainPanel?: ReactNode;
  navPanel?: ReactNode;
  navPanelOpen?: boolean;
  requireAuth?: boolean;
  groupRequestId?: string;
  isManagerView?: boolean;
  asidePanelDefaultWidth?: () => number;
};
export const RequestsLayout = props => {
  const $ = _c(31);
  const pathname = usePathname();
  const window = useWindow();
  const {
    currentUser
  } = useCurrentUser();
  const loginHref = useLoginHref();
  window?.innerWidth;
  currentUser?.isRegistered;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      base: true,
      md: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.groupRequestId || $[2] !== props.isManagerView || $[3] !== props.navPanel) {
    t1 = props.navPanel || <RequestsNav groupRequestId={props.groupRequestId} isManagerView={props.isManagerView} />;
    $[1] = props.groupRequestId;
    $[2] = props.isManagerView;
    $[3] = props.navPanel;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = props.navPanelOpen !== false;
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = {
      id: "requests-nav",
      useDrawerBreakpoints: t0,
      isResizable: true,
      resizeHandlePosition: "right",
      defaultWidth: 280,
      minWidth: 200,
      maxWidth: 400,
      children: t1,
      isPanelOpen: t2,
      isDrawerOpen: false
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== loginHref || $[9] !== props.groupRequestId || $[10] !== props.mainPanel || $[11] !== props.requireAuth) {
    t4 = props.requireAuth ? <UserAccessGate ctaVariant="boxed-card-centered" require={{
      isRegistered: true
    }} ctaProps={{
      boxProps: {
        maxWidth: "container.sm"
      },
      buttons: [{
        title: "Login",
        href: loginHref
      }],
      hideLoginLink: true,
      title: "You don't seem to be logged in."
    }}><ManageRequestAuthGate groupRequestId={props.groupRequestId}>{props.mainPanel}</ManageRequestAuthGate></UserAccessGate> : props.mainPanel;
    $[8] = loginHref;
    $[9] = props.groupRequestId;
    $[10] = props.mainPanel;
    $[11] = props.requireAuth;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== pathname) {
    t5 = pathname?.includes("/tasks");
    $[13] = pathname;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const t6 = !t5;
  let t7;
  if ($[15] !== t4 || $[16] !== t6) {
    t7 = {
      id: "requests-main",
      children: t4,
      isPanelOpen: true,
      isDrawerOpen: true,
      resetScrollOnPathChange: t6
    };
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      base: true,
      lg: false
    };
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = props.asidePanelDefaultWidth || 400;
  const t10 = props.groupRequestId && props.asidePanel ? true : false || !!props.asidePanel;
  let t11;
  if ($[19] !== props.asidePanel || $[20] !== t10 || $[21] !== t9) {
    t11 = {
      id: "requests-aside",
      useDrawerBreakpoints: t8,
      isResizable: true,
      resizeHandlePosition: "left",
      drawerPlacement: "right",
      defaultWidth: t9,
      minWidth: 400,
      maxWidth: 10000,
      children: props.asidePanel,
      isPanelOpen: t10,
      isDrawerOpen: false
    };
    $[19] = props.asidePanel;
    $[20] = t10;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t3 || $[25] !== t7) {
    t12 = [t3, t7, t11];
    $[23] = t11;
    $[24] = t3;
    $[25] = t7;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const panels = t12;
  let t13;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <HubspotHideChatStyles />;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <ScoSiteNavBar />;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== panels) {
    t15 = <>{t13}<AppLayout header={t14} id="requests-v2" panels={panels} /></>;
    $[29] = panels;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  return t15;
};